export default {
  title: '404 - sahifa topilmadi',
  heading: '404 - sahifa topilmadi',
  text1: "Afsuski, bunday sahifa mavjud emas yoki o'chirilgan. ",
  text2: " Asosiy sahifaga o'tish",
}